(ns teamoesterreich.util.log)

(defn log "Log args directly to the browser console"
  [& args]
  (when js/console
    (when-let [con js/console]
      (.apply (.-log con) con (to-array args)))))

(defn log-pr
  "Log pr-str of args to browser console"
  [& args]
  (apply log (map pr-str args)))

(def out log)
(def debug log)
(def prp log-pr)

(enable-console-print!)

(defn *do-log [& args]
  (let [args (mapv clj->js args)]
    (apply js/console.log args)
    ))
